import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ISpace, IBoard } from '../interfaces';
import { LocalStorageService } from '../services/localstorage.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { KeyContents } from '../services/keycontents.service';


@Component({
  selector: 'app-create-board-spaces',
  templateUrl: './create-board-spaces.component.html',
  styleUrls: ['./create-board-spaces.component.scss'],
  providers: [ApiService],
})
export class CreateBoardSpacesComponent implements OnInit {

  @ViewChild('spaceListener') spaceListener: ElementRef;
  @ViewChild('boardTitle') boardTitle: ElementRef;
  @ViewChild('msgBox') msgBox: ElementRef;

  heightDivider: number = 6;
  widthDivider: number = 12;
  cellPercentHeight: number = 100 / this.heightDivider;
  cellPercentWidth: number = 100 / this.widthDivider;
  cellWidth: number = 0;

  editSize: boolean = false;
  editPosition: boolean = false;
  isMoving: boolean = false;
  showGallery: boolean = false;
  shownMsg: boolean = false;
  nameCreated = false;
  isNewBoard = true;
  deletedSpaces = [];

  boardId: number;
  errors: any = {
    name: '',
    project: ''
  };

  lastEvent: any;
  currentSpace: any;
  spaceBoundings: any;
  boardBaseName: string = "Nom de votre planche...";
  board: IBoard = {};

  galleryBoundings = {
    left: '0px',
    top: '0px'
  };

  spaces: Array<any> = [];
  occupancy = {};

  private contentSubscription: any;
  private contents_dict: any = {};
  constructor(
    private _api: ApiService,
    private _router: Router,
    private _storage: LocalStorageService,
    private route: ActivatedRoute,
    private contents_service: KeyContents,

  ) { }

  ngOnInit() {
    this.getSpaceBoundings();
    this.initOccupancy();
    this.getParams();

    this.contentSubscription = this.contents_service.contents.subscribe((el) => {
      this.contents_dict = el;
    })
    this.contents_service.getContents();
  }
  ngOnDestroy() {
    this.contentSubscription.unsubscribe();
  }

  getValue(key) {
    return this.contents_dict.hasOwnProperty(key) ? this.contents_dict[key].value_fr : "";
  }

  getParams() {
    this.route
      .params
      .subscribe(
        (params: Params) => {
          this.boardId = params.id;
          if (this.boardId) {
            this.nameCreated = true;
            this.isNewBoard = false;
            this.getBoard();
          }
        });
  }

  getBoard() {
    this._api.boards
      .retrieve(this.boardId)
      .subscribe(
        (data: IBoard) => {
          this.board = data;
          this.getSpaces();
        },
        (err) => { console.log(err); }
      )
  }

  getSpaces() {
    this._api.boardSpaces
      .list({
        board: this.boardId,
      })
      .subscribe(
        (data) => {
          let spaces = data.results;
          for (let i = spaces.length - 1; i >= 0; i--) {
            let s = spaces[i];
            let space = {
              id: s.id,
              board: this.boardId,
              name: s.name,
              icon: s.icon,
              coords: [s.left_nb, s.top_nb, s.width_nb + s.left_nb - 1, s.height_nb + s.top_nb - 1],
            }

            this.setSpaceFromCoords(space);
            this.setToOccupancy(space.coords);
            this.spaces.push(space);
          }
        },
        (err) => { console.log(err); }
      )
  }

  saveBoard() {
    this.errors = {}
    if (this.spaces.length > 0 && this.board.name != '') {
      let spacesNameFilled = true;
      this.spaces.map((s) => {
        if (s.name == undefined || s.name == '') {
          spacesNameFilled = false;
          return false;
        }
      })

      const board = {
        ...this.board,
        community: this._storage.get('community_id')
      }

      if (spacesNameFilled) {
        if (this.isNewBoard) {
          this._api.boards
            .create(board)
            .subscribe(
              (data: IBoard) => {
                console.log(data);
                this.board = data;
                this.saveSpaces();
              },
              (err) => {
                this.errors = err;
              })
        } else {

          this._api.boards
            .update(this.boardId, board)
            .subscribe(
              (data: IBoard) => {
                console.log(data);
                this.board = data;
                if (this.deletedSpaces.length > 0) {
                  this.deletePile();
                } else {
                  this.saveSpaces();
                }
              },
              (err) => {
                this.errors = err;
              })
        }
      } else {
        const msg = this.getValue('stratbox:all-title-required');
        this.showMsg(msg);
      }
    } else if (this.board.name == undefined || this.board.name == '') {
      const msg = this.getValue('stratbox:no-board-title');
      this.showMsg(msg);
    } else {
      const msg = this.getValue('stratbox:no-spaces');
      this.showMsg(msg);
    }
  }

  deletePile() {
    for (let i = this.deletedSpaces.length - 1; i >= 0; i--) {
      let s = this.deletedSpaces[i];
      s.community_id = this._storage.get('community_id');
      this._api.boardSpaces
        .destroy(s.id, s)
        .subscribe(
          (data) => {
            this.saveSpaces();
          }, (err) => { console.log(err) })
    }
  }

  saveSpaces() {
    for (let i = this.spaces.length - 1; i >= 0; i--) {
      let s = this.spaces[i];
      let space: ISpace = {
        id: s.id,
        board: this.board.id,
        name: s.name,
        width_nb: s.coords[2] - s.coords[0] + 1,
        height_nb: s.coords[3] - s.coords[1] + 1,
        top_nb: s.coords[1],
        left_nb: s.coords[0],
      }
      space.community_id = this._storage.get('community_id');

      if (this.isNewBoard || (s.id == undefined)) {

        this._api.boardSpaces
          .create(space)
          .subscribe(
            (data) => {
              if (i == 0) {
                this._router.navigate(['/board/nouveau', this.board.id]);
              }
            },
            (err) => {
              const msg = this.getValue('stratbox:all-title-required');
              this.showMsg(msg);
            });
      } else {

        console.log(space.id);
        this._api.boardSpaces
          .partialUpdate(space.id, space)
          .subscribe(
            (data) => {
              if (i == 0) {
                this._router.navigate(['/create-board']);
              }
            },
            (err) => {
              const msg = this.getValue('stratbox:all-title-required');
              this.showMsg(msg);
            });
      }
    }
  }

  showMsg(message: string) {
    this.msgBox.nativeElement.innerText = message;
    this.shownMsg = true;

    let that = this;

    setTimeout(function () {
      that.shownMsg = false;
    }, 2500);
  }

  createName() {
    // if (this.nameCreated = ) {
    //   this.nameCreated = true;
    //   this.boardTitle.nativeElement.innerText = '';
    // }
  }

  deleteSpace(s, index) {
    if (!this.isNewBoard && (s.id != undefined)) {
      this.deletedSpaces.push(s);
    }
    this.removeFromOccupancy(this.spaces[index].coords);
    this.spaces.splice(index, 1);
  }

  //////////////////
  // App Behavior //
  //////////////////

  initOccupancy() {
    for (var i = 0; i <= this.widthDivider - 1; i++) {
      for (var j = 0; j <= this.heightDivider - 1; j++) {
        this.occupancy[i + '_' + j] = false;
      }
    }
  }

  getSpaceBoundings() {
    this.spaceBoundings = this.spaceListener.nativeElement.getBoundingClientRect();
    this.cellWidth = this.spaceBoundings.width / this.widthDivider;
  }


  ///////////////////////
  // COORDS UTILITIES  //
  ///////////////////////

  getCoords(event: MouseEvent) {
    let x = event.clientX - this.spaceBoundings.x;
    let y = event.clientY - this.spaceBoundings.y;

    x = Math.round((x - (x % this.cellWidth)) / this.cellWidth);
    y = Math.round((y - (y % this.cellWidth)) / this.cellWidth);

    return [x, y, x, y];
  }

  setSpaceFromCoords(elem: any) {
    let coords = elem.coords;

    elem.left = coords[0] * this.cellPercentWidth + '%';
    elem.top = coords[1] * this.cellPercentHeight + '%';
    elem.width = (coords[2] - coords[0] + 1) * this.cellPercentWidth + '%';
    elem.height = (coords[3] - coords[1] + 1) * this.cellPercentHeight + '%';
  }

  getElemCoords(event: MouseEvent, elem) {
    elem.coords = this.getCoords(event);

    this.setSpaceFromCoords(elem);
    this.setToOccupancy(elem.coords);
    this.spaces.push(elem);
    this.currentSpace = elem;
  }


  ///////////////
  // OCCUPANCY //
  ///////////////

  removeFromOccupancy(coords: Array<number>) {
    for (var i = coords[0]; i <= coords[2]; i++) {
      for (var j = coords[1]; j <= coords[3]; j++) {
        this.occupancy[i + '_' + j] = false;
      }
    }
  }

  setToOccupancy(coords: Array<number>) {
    for (var i = coords[0]; i <= coords[2]; i++) {
      for (var j = coords[1]; j <= coords[3]; j++) {
        this.occupancy[i + '_' + j] = true;
      }
    }
  }

  checkOccupancy(coords: Array<number>) {
    for (var i = coords[0]; i <= coords[2]; i++) {
      for (var j = coords[1]; j <= coords[3]; j++) {
        if (this.occupancy[i + '_' + j] == true) {
          return true;
        }
      }
    }
    return false;
  }

  checkCoordsOccupancy(coords: Array<number>, event: MouseEvent) {
    if (!this.checkOccupancy(coords)) {
      this.currentSpace.coords = coords;
      this.currentSpace.collision = false;
      this.setSpaceFromCoords(this.currentSpace);
    } else {
      this.currentSpace.collision = true;
    }
  }


  ////////////
  // EVENTS //
  ////////////

  mouseEnter(event: MouseEvent) {
    // this.isMoving = true;
  }

  createSpace(event: MouseEvent) {
    this.getSpaceBoundings();

    let currentSpace = {
      coords: Array,
      // name: 'Nom...',
      // endCoords: 0,
      left: '',
      top: '',
      width: this.cellPercentWidth + '%',
      height: this.cellPercentHeight + '%',
      icon: 'pencil',
      collision: false,
    };

    this.getElemCoords(event, currentSpace);
  }

  moveSpace(event: MouseEvent, s) {
    event.stopPropagation();
    this.isMoving = true;
    this.editPosition = true;
    this.lastEvent = {
      clientX: event.clientX,
      clientY: event.clientY
    }
    this.currentSpace = s;
    this.removeFromOccupancy(this.currentSpace.coords);
  }

  resizeSpace(event: MouseEvent, s) {
    this.isMoving = true;
    event.stopPropagation();

    this.editSize = true;
    this.lastEvent = {
      clientX: event.clientX,
      clientY: event.clientY
    }
    this.currentSpace = s;
    this.removeFromOccupancy(this.currentSpace.coords);
  }

  mouseMove(event: MouseEvent) {
    if (this.editSize && this.isMoving) {
      let deltaX = event.clientX - this.lastEvent.clientX;
      let deltaY = event.clientY - this.lastEvent.clientY;
      let directionX = Math.sign(deltaX);
      let directionY = Math.sign(deltaY);
      let coords = [...this.currentSpace.coords];

      if (Math.abs(deltaX) > this.cellWidth / 2) {
        coords[2] = coords[2] + directionX;

        if (coords[2] < this.widthDivider && coords[2] >= coords[0]) {
          this.checkCoordsOccupancy(coords, event);
          this.lastEvent.clientX = (coords[2] + 1) * this.cellWidth + this.spaceBoundings.x;
        }
      }

      if (Math.abs(deltaY) > this.cellWidth / 2) {
        coords[3] = coords[3] + directionY;

        if (coords[3] < this.heightDivider && coords[3] >= coords[1]) {
          this.checkCoordsOccupancy(coords, event);
          this.lastEvent.clientY = (coords[3] + 1) * this.cellWidth + this.spaceBoundings.y;
        }
      }
    } else if (this.editPosition && this.isMoving) {
      let deltaX = event.clientX - this.lastEvent.clientX;
      let deltaY = event.clientY - this.lastEvent.clientY;
      let directionX = Math.sign(deltaX);
      let directionY = Math.sign(deltaY);
      let coords = [...this.currentSpace.coords];

      if (Math.abs(deltaX) > this.cellWidth) {
        coords[0] = coords[0] + directionX;
        coords[2] = coords[2] + directionX;

        if (coords[0] >= 0 && coords[2] < this.widthDivider) {
          this.checkCoordsOccupancy(coords, event);
          this.lastEvent.clientX = event.clientX;
        }
      }

      if (Math.abs(deltaY) > this.cellWidth) {
        coords[1] = coords[1] + directionY;
        coords[3] = coords[3] + directionY;

        if (coords[1] >= 0 && coords[3] < this.heightDivider) {
          this.checkCoordsOccupancy(coords, event);
          this.lastEvent.clientY = event.clientY;
        }
      }
    }
  }

  mouseUp(event: MouseEvent) {
    if (this.editSize || this.editPosition) {
      this.setToOccupancy(this.currentSpace.coords);
    }

    console.log('mouseUp');

    this.showGallery = false;
    this.currentSpace.collision = false;
    this.editSize = false;
    this.editPosition = false;
    this.isMoving = false;
  }

  mouseLeave(event: MouseEvent) {
    this.isMoving = false;
  }

  openGallery(event: MouseEvent) {
    event.stopPropagation();
    let boundings = event.srcElement.getBoundingClientRect();

    console.log(boundings)

    this.galleryBoundings.left = Math.round(boundings.left - 14) + 'px';
    this.galleryBoundings.top = Math.round(boundings.top - 20) + 'px';
    console.log(this.galleryBoundings);
    this.showGallery = true;
  }

  toggleIcon(event: MouseEvent, i: string) {
    event.stopPropagation();
    this.currentSpace.icon = i;
  }

  iconLib = ['home',
    'home2',
    'home3',
    'office',
    'newspaper',
    'pencil',
    'pencil2',
    'quill',
    'pen',
    'blog',
    'eyedropper',
    'droplet',
    'paint-format',
    'image',
    'images',
    'camera',
    'headphones',
    'music',
    'play',
    'film',
    'video-camera',
    'dice',
    'pacman',
    'spades',
    'clubs',
    'diamonds',
    'bullhorn',
    'connection',
    'podcast',
    'feed',
    'mic',
    'book',
    'books',
    'library',
    'file-text',
    'profile',
    'file-empty',
    'files-empty',
    'file-text2',
    'file-picture',
    'file-music',
    'file-play',
    'file-video',
    'file-zip',
    'copy',
    'paste',
    'stack',
    'folder',
    'folder-open',
    'folder-plus',
    'folder-minus',
    'folder-download',
    'folder-upload',
    'price-tag',
    'price-tags',
    'barcode',
    'qrcode',
    'ticket',
    'cart',
    'coin-dollar',
    'coin-euro',
    'coin-pound',
    'coin-yen',
    'credit-card',
    'calculator',
    'lifebuoy',
    'phone',
    'phone-hang-up',
    'address-book',
    'envelop',
    'pushpin',
    'location',
    'location2',
    'compass',
    'compass2',
    'map',
    'map2',
    'history',
    'clock',
    'clock2',
    'alarm',
    'bell',
    'stopwatch',
    'calendar',
    'printer',
    'keyboard',
    'display',
    'laptop',
    'mobile',
    'mobile2',
    'tablet',
    'tv',
    'drawer',
    'drawer2',
    'box-add',
    'box-remove',
    'download',
    'upload',
    'floppy-disk',
    'drive',
    'database',
    'undo',
    'redo',
    'undo2',
    'redo2',
    'forward',
    'reply',
    'bubble',
    'bubbles',
    'bubbles2',
    'bubble2',
    'bubbles3',
    'bubbles4',
    'user',
    'users',
    'user-plus',
    'user-minus',
    'user-check',
    'user-tie',
    'quotes-left',
    'quotes-right',
    'hour-glass',
    'spinner',
    'spinner2',
    'spinner3',
    'spinner4',
    'spinner5',
    'spinner6',
    'spinner7',
    'spinner8',
    'spinner9',
    'spinner10',
    'spinner11',
    'binoculars',
    'search',
    'zoom-in',
    'zoom-out',
    'enlarge',
    'shrink',
    'enlarge2',
    'shrink2',
    'key',
    'key2',
    'lock',
    'unlocked',
    'wrench',
    'equalizer',
    'equalizer2',
    'cog',
    'cogs',
    'hammer',
    'magic-wand',
    'aid-kit',
    'bug',
    'pie-chart',
    'stats-dots',
    'stats-bars',
    'stats-bars2',
    'trophy',
    'gift',
    'glass',
    'glass2',
    'mug',
    'spoon-knife',
    'leaf',
    'rocket',
    'meter',
    'meter2',
    'hammer2',
    'fire',
    'lab',
    'magnet',
    'bin',
    'bin2',
    'briefcase',
    'airplane',
    'truck',
    'road',
    'accessibility',
    'target',
    'shield',
    'power',
    'switch',
    'power-cord',
    'clipboard',
    'list-numbered',
    'list',
    'list2',
    'tree',
    'menu',
    'menu2',
    'menu3',
    'menu4',
    'cloud',
    'cloud-download',
    'cloud-upload',
    'cloud-check',
    'download2',
    'upload2',
    'download3',
    'upload3',
    'sphere',
    'earth',
    'link',
    'flag',
    'attachment',
    'eye',
    'eye-plus',
    'eye-minus',
    'eye-blocked',
    'bookmark',
    'bookmarks',
    'sun',
    'contrast',
    'brightness-contrast',
    'star-empty',
    'star-half',
    'star-full',
    'heart',
    'heart-broken',
    'man',
    'woman',
    'man-woman',
    'happy',
    'happy2',
    'smile',
    'smile2',
    'tongue',
    'tongue2',
    'sad',
    'sad2',
    'wink',
    'wink2',
    'grin',
    'grin2',
    'cool',
    'cool2',
    'angry',
    'angry2',
    'evil',
    'evil2',
    'shocked',
    'shocked2',
    'baffled',
    'baffled2',
    'confused',
    'confused2',
    'neutral',
    'neutral2',
    'hipster',
    'hipster2',
    'wondering',
    'wondering2',
    'sleepy',
    'sleepy2',
    'frustrated',
    'frustrated2',
    'crying',
    'crying2',
    'point-up',
    'point-right',
    'point-down',
    'point-left',
    'warning',
    'notification',
    'question',
    'plus',
    'minus',
    'info',
    'cancel-circle',
    'blocked',
    'cross',
    'checkmark',
    'checkmark2',
    'spell-check',
    'enter',
    'exit',
    'play2',
    'pause',
    'stop',
    'previous',
    'next',
    'backward',
    'forward2',
    'play3',
    'pause2',
    'stop2',
    'backward2',
    'forward3',
    'first',
    'last',
    'previous2',
    'next2',
    'eject',
    'volume-high',
    'volume-medium',
    'volume-low',
    'volume-mute',
    'volume-mute2',
    'volume-increase',
    'volume-decrease',
    'loop',
    'loop2',
    'infinite',
    'shuffle',
    'arrow-up-left',
    'arrow-up',
    'arrow-up-right',
    'arrow-right',
    'arrow-down-right',
    'arrow-down',
    'arrow-down-left',
    'arrow-left',
    'arrow-up-left2',
    'arrow-up2',
    'arrow-up-right2',
    'arrow-right2',
    'arrow-down-right2',
    'arrow-down2',
    'arrow-down-left2',
    'arrow-left2',
    'circle-up',
    'circle-right',
    'circle-down',
    'circle-left',
    'tab',
    'move-up',
    'move-down',
    'sort-alpha-asc',
    'sort-alpha-desc',
    'sort-numeric-asc',
    'sort-numberic-desc',
    'sort-amount-asc',
    'sort-amount-desc',
    'command',
    'shift',
    'ctrl',
    'opt',
    'checkbox-checked',
    'checkbox-unchecked',
    'radio-checked',
    'radio-checked2',
    'radio-unchecked',
    'crop',
    'make-group',
    'ungroup',
    'scissors',
    'filter',
    'font',
    'ligature',
    'ligature2',
    'text-height',
    'text-width',
    'font-size',
    'bold',
    'underline',
    'italic',
    'strikethrough',
    'omega',
    'sigma',
    'page-break',
    'superscript',
    'subscript',
    'superscript2',
    'subscript2',
    'text-color',
    'pagebreak',
    'clear-formatting',
    'table',
    'table2',
    'insert-template',
    'pilcrow',
    'ltr',
    'rtl',
    'section',
    'paragraph-left',
    'paragraph-center',
    'paragraph-right',
    'paragraph-justify',
    'indent-increase',
    'indent-decrease',
    'share',
    'new-tab',
    'embed',
    'embed2',
    'terminal',
    'share2',
    'mail',
    'mail2',
    'mail3',
    'mail4',
    'amazon',
    'google',
    'google2',
    'google3',
    'google-plus',
    'google-plus2',
    'google-plus3',
    'hangouts',
    'google-drive',
    'facebook',
    'facebook2',
    'instagram',
    'whatsapp',
    'spotify',
    'telegram',
    'twitter',
    'vine',
    'vk',
    'renren',
    'sina-weibo',
    'rss',
    'rss2',
    'youtube',
    'youtube2',
    'twitch',
    'vimeo',
    'vimeo2',
    'lanyrd',
    'flickr',
    'flickr2',
    'flickr3',
    'flickr4',
    'dribbble',
    'behance',
    'behance2',
    'deviantart',
    '500px',
    'steam',
    'steam2',
    'dropbox',
    'onedrive',
    'github',
    'npm',
    'basecamp',
    'trello',
    'wordpress',
    'joomla',
    'ello',
    'blogger',
    'blogger2',
    'tumblr',
    'tumblr2',
    'yahoo',
    'yahoo2',
    'tux',
    'appleinc',
    'finder',
    'android',
    'windows',
    'windows8',
    'soundcloud',
    'soundcloud2',
    'skype',
    'reddit',
    'hackernews',
    'wikipedia',
    'linkedin',
    'linkedin2',
    'lastfm',
    'lastfm2',
    'delicious',
    'stumbleupon',
    'stumbleupon2',
    'stackoverflow',
    'pinterest',
    'pinterest2',
    'xing',
    'xing2',
    'flattr',
    'foursquare',
    'yelp',
    'paypal',
    'chrome',
    'firefox',
    'IE',
    'edge',
    'safari',
    'opera',
    'file-pdf',
    'file-openoffice',
    'file-word',
    'file-excel',
    'libreoffice',
    'html-five',
    'html-five2',
    'css3',
    'git',
    'codepen',
    'svg',
    'IcoMoon',
    'uni21',
    'uni22',
    'uni23',
    'uni24',
    'uni25',
    'uni26',
    'uni27',
    'uni28',
    'uni29',
    'uni2A',
    'uni2B',
    'uni2C',
    'uni2D',
    'uni2E',
    'uni2F',
    'uni30',
    'uni31',
    'uni32',
    'uni33',
    'uni34',
    'uni35',
    'uni36',
    'uni37',
    'uni38',
    'uni39',
    'uni3A',
    'uni3B',
    'uni3C',
    'uni3D',
    'uni3E',
    'uni3F',
    'uni40',
    'uni41',
    'uni42',
    'uni43',
    'uni44',
    'uni45',
    'uni46',
    'uni47',
    'uni48',
    'uni49',
    'uni4A',
    'uni4B',
    'uni4C',
    'uni4D',
    'uni4E',
    'uni4F',
    'uni50',
    'uni51',
    'uni52',
    'uni53',
    'uni54',
    'uni55',
    'uni56',
    'uni57',
    'uni58',
    'uni59',
    'uni5A',
    'uni5B',
    'uni5C',
    'uni5D',
    'uni5E',
    'uni5F',
    'uni60',
    'uni61',
    'uni62',
    'uni63',
    'uni64',
    'uni65',
    'uni66',
    'uni67',
    'uni68',
    'uni69',
    'uni6A',
    'uni6B',
    'uni6C',
    'uni6D',
    'uni6E',
    'uni6F',
    'uni70',
    'uni71',
    'uni72',
    'uni73',
    'uni74',
    'uni75',
    'uni76',
    'uni77',
    'uni78',
    'uni79',
    'uni7A',
    'uni7B',
    'uni7C',
    'uni7D',
    'uni7E',
    'uniA9'];
}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/create-board-spaces/create-board-spaces.component.ts